import script from "./ChangeSubscriptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeSubscriptionModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangeSubscriptionModal.vue?vue&type=style&index=0&id=e653968c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e653968c"]])

export default __exports__